import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api.js';
import './Board.css';

const STAGE_COLORS = { gray: '#808080', blue: '#3b82f6', purple: '#8b5cf6', orange: '#f59e0b', green: '#22c55e', red: '#ef4444' };
const eur = (n) => new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n || 0);

const Board = ({ object }) => {
  const navigate = useNavigate();
  const [stages, setStages] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dragId, setDragId] = useState(null);

  const load = async () => {
    setLoading(true); setError(null);
    try {
      const [sR, rR] = await Promise.all([
        api.get(`/pipeline/${object.id}/stages`),
        api.get(`/${object.id}/records`, { params: { pageSize: 500 } })
      ]);
      setStages(sR.data || []);
      setRecords((rR.data && rR.data.records) || []);
    } catch (e) { setError(e.message); } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [object.id]);

  const onDrop = async (stageId, e) => {
    e.preventDefault(); const id = dragId; setDragId(null);
    const rec = records.find((r) => r.id === id);
    if (!rec || rec.stage_id === stageId) return;
    try {
      await api.put(`/byid/${rec.id}/stage`, { stage_id: stageId });
      setRecords((rs) => rs.map((r) => (r.id === rec.id ? { ...r, stage_id: stageId } : r)));
    } catch (err) { setError(err.message); }
  };

  if (loading) return <div className="gencrm_ws_empty">A carregar board...</div>;
  if (error) return <div className="gencrm_ws_error">Erro: {error}</div>;
  if (!stages.length) return <div className="gencrm_ws_empty">Este objeto não tem pipeline.</div>;

  return (
    <div className="gencrm_board">
      {stages.map((st) => {
        const cards = records.filter((r) => r.stage_id === st.id);
        const color = STAGE_COLORS[st.color] || '#808080';
        return (
          <div key={st.id} className="gencrm_board__col"
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => onDrop(st.id, e)}>
            <div className="gencrm_board__head" style={{ borderTopColor: color }}>
              <span className="gencrm_board__title">{st.name}</span>
              <span className="gencrm_board__count">{cards.length}</span>
            </div>
            <div className="gencrm_board__sum">{eur(cards.reduce((s, c) => s + (c.amount || 0), 0))}</div>
            <div className="gencrm_board__cards">
              {cards.map((c) => (
                <div key={c.id} className="gencrm_card" draggable
                  onDragStart={() => setDragId(c.id)}
                  onClick={() => navigate(`/r/${c.id}`)}>
                  <div className="gencrm_card__name">{c.name}</div>
                  {c.amount ? <div className="gencrm_card__amount">{eur(c.amount)}</div> : null}
                  <div className="gencrm_card__num">{c.record_number}</div>
                </div>
              ))}
              {cards.length === 0 && <div className="gencrm_board__empty">Solte cartões aqui</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Board;
